import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const Sidebar = ({ categories, onCategoryChange, activeCategory, onShowSuggestions, showSuggestions }) => {
  const priorityOrder = ['Lunchs', 'Plats', 'Desserts'];

  // Trie les catégories : priorités d’abord, puis le reste par ordre alphabétique
  const sortedCategories = [
    ...priorityOrder.filter(cat => categories.includes(cat)),
    ...categories
      .filter(cat => !priorityOrder.includes(cat))
      .sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }))
  ];

  return (
    <div className="sidebar">
      {sortedCategories.length > 0 ? (
        sortedCategories.map((category, index) => (
          <button
            key={index}
            className={`category-button ${category === activeCategory ? 'active' : ''}`}
            onClick={() => onCategoryChange(category)}
          >
            {category}
          </button>
        ))
      ) : (
        <div>Aucune catégorie disponible</div>
      )}

      <button className={`btn-suggestions ${showSuggestions ? 'active' : ''}`} onClick={onShowSuggestions}>
        carte
      </button>
    </div>
  );
};

export default Sidebar;
